import React from "react";
import classes from "./TermsModal.module.css";

const TermsModal = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div className={classes.overlay}>
      <div className={classes.modal}>
        <h2>Terms & Conditions</h2>

        <div className={classes.content}>
          <p>
            Welcome to GamePlex. By subscribing or using our services, you agree
            to the following terms:
          </p>

          <ul>
            <li>Subscription fees are non-refundable.</li>
            <li>You must be at least 18 years old to subscribe.</li>
            <li>Service will auto-renew unless cancelled.</li>
            <li>Standard data charges may apply.</li>
          </ul>

          <p>
            Please read all terms carefully before continuing.
          </p>
        </div>

        <button className={classes.closeBtn} onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default TermsModal;